import dayjs from 'dayjs'
import { MeetingSportsPreview, RaceSportsPreview } from './types'

export type RaceSportsContent = Omit<
  MeetingSportsPreview,
  'raceCourseSeq' | 'meetingDate' | 'racePreviews'
> & {
  racePreviews: Map<number, RaceSportsPreview>
}

export async function getRaceSportsPreviews(
  meetingDate: Date,
  racecourseSeq: number
): Promise<RaceSportsContent> {
  const response = await fetch(
    `/api/race-preview-tips/${dayjs(meetingDate).format('YYYY-MM-DD')}/${racecourseSeq}`
  )
  if (response.ok) {
    const meetingPreview: MeetingSportsPreview = await response.json()
    return {
      title: meetingPreview.title,
      racePreviews: new Map<number, RaceSportsPreview>(
        meetingPreview.racePreviews?.map(preview => [preview.raceNumber, preview])
      ),
      tipsterProfilePictureUrl: meetingPreview.tipsterProfilePictureUrl,
    }
  }
  throw new Error()
}
